import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { domicileCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Domiciles{" "}
    <Link className="button" to="/admin/platform/reference/domicile/new">
      New Domicile
    </Link>
  </Fragment>
);

export default function DomicilePage(): ReactNode {
  return (
    <PageLayout title="Reference Platform - Domicile">
      <PaginatedList title={title} collection={domicileCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Domicile ID</th>
              <th>Name</th>
              <th>ISO Code</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, name, isoCode }) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{name}</td>
                <td>{isoCode}</td>
                <td>
                  <Link to={`/admin/platform/reference/domicile/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
